import PropTypes from 'prop-types';
import { branch, compose, defaultProps, setPropTypes, withProps } from 'recompose';
import { withFocusProps, withHoverProps, withUncontrolledProp, withUniqueFormIdentifier
// @ts-expect-error
} from '@klarna/higher-order-components';

/**
 * @deprecated this type is outdated and will be removed with v6.0.0
 */

/**
 * @deprecated this type is outdated and will be removed with v6.0.0
 */

var baseDropdown = compose(setPropTypes({
  arrow: PropTypes.oneOf(['top-left', 'top', 'top-right', 'right-top', 'right', 'right-bottom', 'bottom-left', 'bottom', 'bottom-right', 'left-top', 'left', 'left-bottom']),
  autofill: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fieldTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  fieldTooltipAriaLabel: PropTypes.string,
  fieldTooltipFluidWidth: PropTypes.bool,
  hasDegradedPerformance: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onDisabledClick: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool
  })),
  testID: PropTypes.string,
  tooltipActive: PropTypes.bool,
  value: PropTypes.string,
  warning: PropTypes.bool,
  hovered: PropTypes.bool,
  focused: PropTypes.bool
}), withUniqueFormIdentifier, withUncontrolledProp({
  prop: 'value',
  defaultProp: 'defaultValue',
  handlers: {
    onChange: () => value => value
  }
}), branch(_ref => {
  var {
    hasDegradedPerformance
  } = _ref;
  return !hasDegradedPerformance;
}, compose(withFocusProps({
  focused: true
}), withHoverProps({
  hovered: true
}))), defaultProps({
  value: ''
}), withProps(_ref2 => {
  var {
    id,
    options,
    value
  } = _ref2;
  return {
    hasValue: value && value.length > 0,
    ids: id ? {
      root: "".concat(id, "__root"),
      background: "".concat(id, "__background"),
      loader: "".concat(id, "__loader"),
      fieldTooltip: "".concat(id, "__tooltip"),
      arrowWrapper: "".concat(id, "__arrow-wrapper"),
      arrow: "".concat(id, "__arrow"),
      label: "".concat(id, "__label"),
      selectedOption: "".concat(id, "__selected-option"),
      select: id,
      textWrapper: "".concat(id, "__text-wrapper"),
      option: value => "".concat(id, "__option__").concat(value)
    } : {
      option: () => undefined
    },
    selectedOption: options && value !== '' && options.find(option => String(option.key) === String(value))
  };
}));

/**
 * @deprecated this package is outdated and will be removed with v6.0.0
 */
export default baseDropdown;
//# sourceMappingURL=index.js.map